import { Container, Stack, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAddPolicyMutation } from '../../../app/Slices/SevenDayApiSlice';
import UserRole from '../../../shared/AuthRoles';
import PolicyForm from '../../components/Policies/PolicyForm';
import toast from '../../shared/Toast';
import { Policy } from '../../types/policy';

const AddPolicyPage = () => {
    const loggedInUser = UserRole();
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');

    const navigate = useNavigate();

    const [addPolicy] = useAddPolicyMutation();

    const onSubmit = (data: Policy) => {
        addPolicy([loggedInUser?.company, data]).then((data: any) => {
            if (data?.error) {
                toast.error(data.error.data.message);
            } else {
                toast.success(`New policy has been created`);
                navigate('/policies');
            }
        });
    };

    useEffect(() => {
        if (loggedInUser.role !== 'owner_admin') {
            navigate(`/permissionDenied`, {
                state: {
                    name: 'policiesPage',
                },
            });
        }
    }, [loggedInUser.role]);

    return (
        <Stack width='100%' height='90%' gap='40px'>
            <Typography
                variant='h1'
                sx={{
                    textAlign: 'left',
                    textTransform: 'uppercase',
                }}
            >
                NEW POLICY
            </Typography>
            <PolicyForm onSubmit={onSubmit} />
        </Stack>
    );
};

export default AddPolicyPage;
